import styled from 'styled-components'
import { breakpoint } from '@sketch/global-styles'

export const Wrapper = styled.div`
  max-height: calc(100vh / 2);
  display: flex;
  flex-direction: column;
  margin: -8px 0;

  /* Prevent the canvas cursor from influencing */
  cursor: default;

  ${breakpoint('sm')`
      width: 295px;
  `}
`
